"use client";

import { ColorPicker } from "@/components/admin/content/ColorPicker";
import CardSetting from "@/components/admin/settings/CardSetting";
import { Button } from "@/components/ui/button";
import { Label } from "@/components/ui/label";
import {
    Popover,
    PopoverTrigger,
    PopoverContent,
} from "@/components/ui/popover";
import { Switch } from "@/components/ui/switch";
import { IBlocks } from "@/types";
import React from "react";
interface Props {
    block: IBlocks;
    update: (value: IBlocks) => void;
}
export default function FourthwallCustomization({ block, update }: Props) {
    const onChangeProductBackground = (value: string) => {
        update({
            ...block,
            options: {
                ...block.options,
                product_background: value,
            },
        });
    };
    const onChangeProductText = (value: string) => {
        update({
            ...block,
            options: {
                ...block.options,
                product_text: value,
            },
        });
    };
    const onChangeStoreButtonBackground = (value: string) => {
        update({
            ...block,
            options: {
                ...block.options,
                store_button_background: value,
            },
        });
    };
    const onChangeStoreButtonText = (value: string) => {
        update({
            ...block,
            options: {
                ...block.options,
                store_button_text: value,
            },
        });
    };
    return (
        <div className="flex w-full flex-col gap-3">
            <CardSetting title="Customization" noBorder>
                <div className="flex items-center justify-between">
                    <Label variant="toggle">Custom theme</Label>
                    <Switch
                        onCheckedChange={(checked) =>
                            update({
                                ...block,
                                options: {
                                    ...block.options,
                                    custom_theme: checked,
                                },
                            })
                        }
                        checked={block.options?.custom_theme}
                    />
                </div>
                {block.options?.custom_theme && (
                    <div className="flex flex-col gap-3">
                        <div className="flex items-center justify-between gap-4 pt-3">
                            <div className="">
                                <Label>Product Background</Label>
                            </div>
                            <Popover>
                                <PopoverTrigger asChild>
                                    <Button
                                        className="h-9 w-9 rounded-full border-2 border-primary"
                                        style={{
                                            background:
                                                block.options
                                                    ?.product_background,
                                        }}
                                    ></Button>
                                </PopoverTrigger>
                                <PopoverContent className="z-[999]">
                                    <ColorPicker
                                        gradient
                                        value={
                                            block.options?.product_background
                                        }
                                        onChange={onChangeProductBackground}
                                    />
                                </PopoverContent>
                            </Popover>
                        </div>
                        <div className="flex items-center justify-between gap-4">
                            <div className="">
                                <Label>Product Text</Label>
                            </div>
                            <Popover>
                                <PopoverTrigger asChild>
                                    <Button
                                        className="h-9 w-9 rounded-full border-2 border-primary"
                                        style={{
                                            background:
                                                block.options?.product_text,
                                        }}
                                    ></Button>
                                </PopoverTrigger>
                                <PopoverContent className="z-[999]">
                                    <ColorPicker
                                        value={block.options?.product_text}
                                        onChange={onChangeProductText}
                                    />
                                </PopoverContent>
                            </Popover>
                        </div>
                        <div className="flex items-center justify-between gap-4">
                            <div className="">
                                <Label>Store Button Background</Label>
                            </div>
                            <Popover>
                                <PopoverTrigger asChild>
                                    <Button
                                        className="h-9 w-9 rounded-full border-2 border-primary"
                                        style={{
                                            background:
                                                block.options
                                                    ?.store_button_background,
                                        }}
                                    ></Button>
                                </PopoverTrigger>
                                <PopoverContent className="z-[999]">
                                    <ColorPicker
                                        gradient
                                        value={
                                            block.options
                                                ?.store_button_background
                                        }
                                        onChange={onChangeStoreButtonBackground}
                                    />
                                </PopoverContent>
                            </Popover>
                        </div>
                        <div className="flex items-center justify-between gap-4">
                            <div className="">
                                <Label>Store Button Text</Label>
                            </div>
                            <Popover>
                                <PopoverTrigger asChild>
                                    <Button
                                        className="h-9 w-9 rounded-full border-2 border-primary"
                                        style={{
                                            background:
                                                block.options
                                                    ?.store_button_text,
                                        }}
                                    ></Button>
                                </PopoverTrigger>
                                <PopoverContent className="z-[999]">
                                    <ColorPicker
                                        value={block.options?.store_button_text}
                                        onChange={onChangeStoreButtonText}
                                    />
                                </PopoverContent>
                            </Popover>
                        </div>
                    </div>
                )}
            </CardSetting>
        </div>
    );
}
